import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { Button, ButtonProps, Modal, ModalContent } from '@restworld/ui-ds-base';

import { cn } from '@restworld/utils-common';
export interface IFormModalWrapper {
  loading?: boolean;
  onSubmitHandler?: () => void;
  onCancelHandler?: () => void;
  modalVisible?: boolean;
  onModalClose?: () => void;
  title?: string;
  subTitle?: string;
  submitHandlerProps?: ButtonProps;
  headerIcon?: React.ReactNode;
  onCancelHandlerProps?: ButtonProps;
  showCloseIcon?: boolean;
  disableDrag?: boolean;
}

export const ModalToggleWrapper = ({
  children,
  loading,
  onSubmitHandler,
  onCancelHandler,
  modalVisible,
  onModalClose,
  title,
  subTitle,
  submitHandlerProps,
  headerIcon,
  onCancelHandlerProps,
  showCloseIcon,
  disableDrag,
}: React.PropsWithChildren<IFormModalWrapper>) => {
  const { t } = useTranslation('common');

  const footer = React.useMemo(
    () => (
      <div className="flex flex-row gap-5 w-full">
        {(onCancelHandler || onCancelHandlerProps?.onClick) && (
          <Button fullwidth variant="tertiary" onClick={onCancelHandler} {...onCancelHandlerProps}>
            {t('cancel')}
          </Button>
        )}
        <Button loading={loading} fullwidth onClick={onSubmitHandler} variant="primary" {...submitHandlerProps}>
          {t('confirm')}
        </Button>
      </div>
    ),
    [loading, onCancelHandler, onCancelHandlerProps, onSubmitHandler, submitHandlerProps, t]
  );
  const header = React.useMemo(
    () => (
      <div className="flex flex-col gap-8 items-center px-6">
        {headerIcon ?? ''}
        <h2 className="text-xl leading-7.5 text-neutral-700 font-semibold text-center">{title}</h2>
        <h5 className="text-base font-medium text-neutral-200 text-center">{subTitle}</h5>
      </div>
    ),
    [headerIcon, subTitle, title]
  );
  return (
    <Modal open={modalVisible} onOpenChange={(v) => !v && onModalClose()}>
      <ModalContent className="md:max-w-md" footer={footer} title={header} showCloseIcon={showCloseIcon}>
        <Form action="#!" method="post" onSubmit={(e) => e.preventDefault()}>
          {children}
        </Form>
      </ModalContent>
    </Modal>
  );
};

const Form = ({ className, ...props }: React.FormHTMLAttributes<HTMLFormElement>) => (
  <form className={cn('flex flex-col gap-8 pb-12 pt-4 w-full', className)} {...props} />
);
